
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.002 0a.519.519 0 00-.332.12L1.103 5.05C.444 5.478-.017 6.427.001 6.88v9.235c-.008.9 1.202 1.88 2.009 1.885h13.88c1.116.004 2.109-1.067 2.109-1.963V7.03c.003-.663-.046-1.237-1.294-2.059L9.334.118A.517.517 0 009.002 0zm-.008 1.428l7.192 4.742-7.088 5.875L1.832 6.17zM1.19 6.811l4.793 3.947L1.19 16.14zm15.681.004l.051 9.332-4.846-5.312zM6.743 11.383l2.027 1.67c.19.158.474.157.664-.002l1.89-1.584 4.938 5.411H1.848z","font-family":"sans-serif","overflow":"visible","paint-order":"markers stroke fill"}})])
          )
        }
      }
    